import React from "react";
import { NavLink, useNavigate } from "react-router-dom";

const links = [
  {
    to: "/", label: "Dashboard", exact: true,
    icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  },
  {
    to: "/restaurants/new", label: "Adaugă restaurant", exact: false,
    icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  },
];

export default function Sidebar() {
  const nav = useNavigate();
  const logout = () => { localStorage.removeItem("hubToken"); nav("/login"); };

  return (
    <aside style={{ width: 230, background: "#fff", borderRight: "1px solid #f1f5f9", display: "flex", flexDirection: "column", minHeight: "100vh", position: "sticky", top: 0, flexShrink: 0 }}>
      {/* Logo */}
      <div style={{ padding: "22px 20px 18px", borderBottom: "1px solid #f1f5f9" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 34, height: 34, borderRadius: 9, background: "linear-gradient(135deg,#6366f1,#818cf8)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
          </div>
          <div>
            <div style={{ fontWeight: 800, fontSize: 14, color: "#0f172a", lineHeight: 1.1, letterSpacing: "-0.2px" }}>Orderly</div>
            <div style={{ fontSize: 10, fontWeight: 700, color: "#6366f1", letterSpacing: "1px", textTransform: "uppercase" }}>Hub</div>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: "14px 12px", display: "flex", flexDirection: "column", gap: 2 }}>
        <p style={{ fontSize: 10, fontWeight: 700, color: "#cbd5e1", textTransform: "uppercase", letterSpacing: "0.8px", padding: "6px 8px 8px", margin: 0 }}>Navigare</p>
        {links.map(l => (
          <NavLink key={l.to} to={l.to} end={l.exact}
            style={({ isActive }) => ({
              display: "flex", alignItems: "center", gap: 10, padding: "9px 10px", borderRadius: 9,
              textDecoration: "none", fontSize: 13, fontWeight: 600, transition: "all 0.12s",
              background: isActive ? "#eef2ff" : "transparent",
              color: isActive ? "#6366f1" : "#64748b",
            })}>
            {l.icon}
            {l.label}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div style={{ padding: "14px 12px", borderTop: "1px solid #f1f5f9" }}>
        <button onClick={logout}
          style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "9px 10px", borderRadius: 9, border: "none", background: "transparent", color: "#94a3b8", fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "all 0.12s" }}
          onMouseEnter={e => { e.currentTarget.style.background = "#fff1f2"; e.currentTarget.style.color = "#ef4444"; }}
          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#94a3b8"; }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          Deconectare
        </button>
      </div>
    </aside>
  );
}
